const customTheme = {
  token: {
    // Add any theme customization here
  },
};

export default customTheme;
